import { useTranslation } from "react-i18next";

export default function useSuperAdminFinanceMenuOptions() {
	const { t } = useTranslation();

	return [
		{
			path: "cloud-revenues",
			name: t("cloudRevenues", "Cloud revenues"),
		},
		{
			path: "sales-orders",
			name: t("salesOrders", "Sales orders"),
		},
		{
			path: "cloud-agreements",
			name: t("cloudAgreements", "Cloud agreements"),
		},
	];
}
